import { post } from '@/libs/api';

// Preserve the original transport, authentication and response contract.
function request(url, params) {
    return new Promise((resolve, reject) => {
        post(url, params, response => {
            if (response && response.code === 200) resolve(response.data);
            else reject(new Error('首页数据暂时无法加载'));
        }, null, reject);
    });
}

export const homeApi = {
    statistics: () => request('/task/index/index_data', {}),
    projects: hot => request('/task/index/task_list', hot
        ? { type: 'hot', page: 1, limit: 5 } : { page: 1, limit: 5 }),
    geeks: () => request('/user/index/geek_list', { page: 1, limit: 5 }),
    partners: () => request('/article/index/lists', { profession: 2, page: 1, limit: 5 }),
    banners: () => request('/article/index/lists', { profession: 31, page: 1, limit: 10 })
};

export function safeLink(value) {
    if (typeof value !== 'string') return '';
    const link = value.trim();
    return /^(https?:\/\/|\/(?!\/))[^\s]*$/i.test(link) ? link : '';
}



// WEBPACK FOOTER //
// ./src/api/home.js